import request from '@/utils/seftRequest';

// 加装 drm/ding/subsService/addServicesBsnl
export function addServices(data) {
  return request('/ding/subsService/addServicesBsnl', {
    method: 'POST',
    body: data,
  });
}

// 查询可加装主产品类型接口 /drm/ding/custService/qryAddServicesProdListBsnl
export function qryAddServicesProdList(data) {
  return request('/ding/custService/qryAddServicesProdListBsnl', {
    method: 'POST',
    body: data,
  });
}
